import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComissaoRoutingModule } from './comissao-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ComissaoRoutingModule
  ]
})
export class ComissaoModule { }
